export default "__VITE_ASSET__fd4e4a4d__"